<div class="notice-banner" [class.information]="theme === 'information'" role="status">
  <div class="banner-content">
    <div class="banner-info">
      <div class="warning-icon">
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M12 8c-3.866 0-7 3.134-7 7 0 1.657.54 3.182 1.457 4.408L12 20l5.543-4.592A6.985 6.985 0 0019 15c0-3.866-3.134-7-7-7z"
          />
        </svg>
      </div>
      <div class="banner-text">
        <ng-content></ng-content>
      </div>
    </div>
    <button
      class="banner-button"
      type="button"
      (click)="dismiss.emit()"
      [attr.aria-label]="dismissLabel"
    >
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
      </svg>
      Dismiss
    </button>
  </div>
</div>
